import { render, staticRenderFns } from "./LayoutTwo.vue?vue&type=template&id=2dd79eb4&scoped=true&"
import script from "./LayoutTwo.vue?vue&type=script&lang=js&"
export * from "./LayoutTwo.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTwo.vue?vue&type=style&index=0&id=2dd79eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd79eb4",
  null
  
)

export default component.exports